import {
    AggregateFunctions,
    ApiQuery,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";
import { DEFAULT_FUND_FLOWS_QUERY } from "../consts";

// // // //

/**
 * buildFundFlowsQuery
 * Builds the API query for the Fund Flows API
 * @param props - The properties for the query
 * @param props.name - The name for the query
 * @param props.filters - The filters for the query
 * @param props.groupBy - The group by for the query
 * @param props.startDate - The start date for the query
 * @param props.endDate - The end date for the query
 * @returns
 */
export function buildFundFlowsQuery(props: {
    name?: string;
    filters?: Filter[];
    groupBy: TokenTimeseriesGroupBy;
    startDate: string;
    endDate?: string;
}): ApiQuery {
    const input = props;

    // Construct the filters for the Fund Flows API
    const filters: Filter[] = input.filters ? [...input.filters] : [];

    // Add the date filters to the filters array
    if (input.startDate) {
        filters.push({
            field: TokenTimeseriesColumns.date,
            operator: FilterOperators.OnOrAfter,
            value: input.startDate,
        });
    }

    // Add the end date filter to the filters array
    if (input.endDate) {
        filters.push({
            field: TokenTimeseriesColumns.date,
            operator: FilterOperators.OnOrBefore,
            value: input.endDate,
        });
    }

    // Construct the ApiQuery object for the Fund Flows API
    const apiQuery: ApiQuery = {
        ...DEFAULT_FUND_FLOWS_QUERY,
        name: input.name,
        filter: {
            operator: FilterOperators.And,
            filters,
        },
        aggregate: {
            ...DEFAULT_FUND_FLOWS_QUERY.aggregate,
            groupBy: input.groupBy,
            aggregateFunction: AggregateFunctions.Sum,
        },
    };

    return apiQuery;
}
